{ "compressionlevel":-1,
 "height":28,
 "infinite":false,
 "layers":[
        {
         "data":[2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26, 27, 28, 29, 30, 31, 29, 30, 29, 27, 28, 28, 29, 30, 27, 28, 29, 30, 29, 27, 29, 30, 31, 32, 33, 34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 73, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 9, 10, 11, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 35, 0, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 9, 10, 11, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14, 35, 18, 17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 145, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 9, 10, 11, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26, 27, 28, 29, 30, 31, 32, 33, 34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 85, 86, 87, 88, 89, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16, 14, 0, 13, 14, 15, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 103, 104, 105, 106, 107, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 9, 10, 11, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26, 27, 28, 29, 30, 31, 32, 30, 28, 29, 30, 31, 32, 33, 34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 121, 122, 123, 124, 125, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14, 35, 18, 17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 17, 14, 13, 14, 17, 36, 17, 18, 13, 14, 15, 16, 17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 157, 158, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2147483807, 2147483806, 2147483805, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 2684354599, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 139, 140, 141, 142, 143, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 175, 176, 177, 177, 177, 177, 177, 177, 177, 177, 177, 177, 177, 177, 177, 177, 177, 177, 177, 177, 177, 2147483825, 2147483824, 2147483823, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2684354599, 37, 38, 39, 40, 41, 42, 43, 44, 45, 47, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 0, 0, 0, 1, 2, 3, 4, 5, 6, 7, 0, 0, 0, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 157, 157, 0, 37, 38, 39, 40, 41, 42, 43, 44, 45, 47, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 0, 0, 0, 0, 0, 37, 38, 39, 40, 49, 50, 51, 52, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 37, 38, 39, 40, 41, 42, 43, 44, 45, 41, 47, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 40, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 0, 0, 0, 37, 38, 39, 3, 4, 5, 6, 7, 0, 0, 0, 1, 2, 3, 4, 5, 6, 7, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 195, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 0, 0, 0, 19, 20, 21, 22, 23, 24, 25, 0, 0, 0, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 67, 68, 69, 70, 71, 72, 157, 157, 0, 55, 56, 57, 58, 59, 60, 61, 62, 57, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 0, 0, 0, 0, 0, 55, 56, 57, 58, 67, 68, 69, 70, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 55, 56, 57, 58, 59, 60, 61, 62, 63, 58, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 0, 0, 0, 55, 56, 57, 59, 22, 23, 24, 25, 0, 0, 0, 19, 20, 21, 22, 23, 24, 25, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72],
         "height":28,
         "id":1,
         "name":"ground",
         "opacity":1,
         "type":"tilelayer",
         "visible":true,
         "width":230,
         "x":0,
         "y":0
        }, 
        {
         "draworder":"topdown",
         "id":2,
         "name":"objects",
         "objects":[
                {
                 "height":50,
                 "id":119,
                 "name":"doll",
                 "rotation":-90,
                 "type":"present",
                 "visible":true,
                 "width":50,
                 "x":4800,
                 "y":1320
                }, 
                {
                 "height":60,
                 "id":5,
                 "name":"robot",
                 "rotation":0,
                 "type":"present",
                 "visible":true,
                 "width":60,
                 "x":1230,
                 "y":1080
                }, 
                {
                 "height":60,
                 "id":16,
                 "name":"carebear",
                 "rotation":0,
                 "type":"present",
                 "visible":true,
                 "width":60,
                 "x":2850,
                 "y":842
                }, 
                {
                 "height":50,
                 "id":20,
                 "name":"dino",
                 "rotation":0,
                 "type":"present",
                 "visible":true,
                 "width":50,
                 "x":6120,
                 "y":1320
                }, 
                {
                 "height":48,
                 "id":1,
                 "name":"santaSpawn",
                 "rotation":0,
                 "type":"santaSpawn",
                 "visible":true,
                 "width":48,
                 "x":500,
                 "y":500
                }, 
                {
                 "height":60.6061,
                 "id":120,
                 "name":"snowman3",
                 "rotation":0,
                 "type":"snowman",
                 "visible":true,
                 "width":57.5758,
                 "x":4250,
                 "y":933.7
                }, 
                {
                 "height":60.6061,
                 "id":22,
                 "name":"snowman2",
                 "rotation":0,
                 "type":"snowman",
                 "visible":true,
                 "width":57.5758,
                 "x":6480,
                 "y":1320
                }, 
                {
                 "height":60.6061,
                 "id":55,
                 "name":"snowman1",
                 "rotation":0,
                 "type":"snowman",
                 "visible":true,
                 "width":57.5758,
                 "x":5760,
                 "y":1320
                }, 
                {
                 "height":60,
                 "id":72,
                 "name":"ginger2",
                 "rotation":0,
                 "type":"ginger",
                 "visible":true,
                 "width":60,
                 "x":2840,
                 "y":1440
                }, 
                {
                 "height":60,
                 "id":64,
                 "name":"ginger1",
                 "rotation":0,
                 "type":"ginger",
                 "visible":true,
                 "width":60,
                 "x":2840,
                 "y":970
                }, 
                {
                 "height":49.3333,
                 "id":100,
                 "name":"elf7",
                 "rotation":0,
                 "type":"elf",
                 "visible":true,
                 "width":52,
                 "x":9725,
                 "y":931
                }, 
                {
                 "height":49.3333,
                 "id":101,
                 "name":"elf6",
                 "rotation":0,
                 "type":"elf",
                 "visible":true,
                 "width":52,
                 "x":9525,
                 "y":931
                }, 
                {
                 "height":49.3333,
                 "id":83,
                 "name":"elf5",
                 "rotation":0,
                 "type":"elf",
                 "visible":true,
                 "width":52,
                 "x":9325,
                 "y":931
                }, 
                {
                 "height":49.3333,
                 "id":84,
                 "name":"elf4",
                 "rotation":0,
                 "type":"elf",
                 "visible":true,
                 "width":52,
                 "x":9125,
                 "y":931
                }, 
                {
                 "height":49.3333,
                 "id":85,
                 "name":"elf3",
                 "rotation":0,
                 "type":"elf",
                 "visible":true,
                 "width":52,
                 "x":8925,
                 "y":931
                }, 
                {
                 "height":49.3333,
                 "id":77,
                 "name":"elf2",
                 "rotation":0,
                 "type":"elf",
                 "visible":true,
                 "width":52,
                 "x":8725,
                 "y":931
                }, 
                {
                 "height":49.3333,
                 "id":86,
                 "name":"elf1",
                 "rotation":0,
                 "type":"elf",
                 "visible":true,
                 "width":52,
                 "x":8525,
                 "y":931
                }, 
                {
                 "height":1000,
                 "id":111,
                 "name":"preBattle",
                 "rotation":0,
                 "type":"preBattle",
                 "visible":true,
                 "width":60,
                 "x":11160,
                 "y":1100
                }, 
                {
                 "height":32,
                 "id":115,
                 "name":"krampus",
                 "rotation":0,
                 "type":"krampus",
                 "visible":true,
                 "width":32,
                 "x":12600,
                 "y":700
                }, 
                {
                 "height":136,
                 "id":117,
                 "name":"killZone",
                 "rotation":0,
                 "type":"killZone",
                 "visible":false,
                 "width":21700,
                 "x":0,
                 "y":1900
                }, 
                {
                 "height":151,
                 "id":142,
                 "name":"Car2",
                 "rotation":0,
                 "type":"carRec2",
                 "visible":true,
                 "width":62,
                 "x":3665,
                 "y":1412
                }, 
                {
                 "height":225,
                 "id":137,
                 "name":"Car1",
                 "rotation":0,
                 "type":"carRec1",
                 "visible":true,
                 "width":250,
                 "x":3729,
                 "y":1343
                }, 
                {
                 "height":0,
                 "id":147,
                 "name":"Car3",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        }, 
                        {
                         "x":39,
                         "y":-69
                        }, 
                        {
                         "x":40,
                         "y":1
                        }],
                 "rotation":0,
                 "type":"carPoly",
                 "visible":true,
                 "width":0,
                 "x":3690,
                 "y":1413
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":false,
         "x":0,
         "y":0
        }],
 "nextlayerid":5,
 "nextobjectid":150,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.7.2",
 "tileheight":60,
 "tilesets":[
        {
         "columns":18,
         "firstgid":1,
         "image":"platform_sheet.png",
         "imageheight":1080,
         "imagewidth":1080,
         "margin":0,
         "name":"iceworld",
         "spacing":0,
         "tilecount":324,
         "tileheight":60,
         "tiles":[
                {
                 "id":0,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":1,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":2,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":3,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":4,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":5,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":6,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":7,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":8,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":9,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":10,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":11,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":12,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":13,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":14,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":15,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":16,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":17,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":18,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":19,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":20,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":21,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":22,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":23,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":24,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":25,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":26,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":27,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":28,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":29,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":30,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":31,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":32,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":33,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":34,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":35,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":36,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":37,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":38,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":39,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":40,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":41,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":42,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":43,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":44,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":45,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":46,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":47,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":48,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":49,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":50,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":51,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":52,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":53,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":54,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":55,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":56,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":57,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":58,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":59,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":60,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":61,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":62,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":63,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":64,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":65,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":66,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":67,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":68,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":69,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":70,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":71,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":72,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":73,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":74,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":75,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":76,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":77,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":78,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":79,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":80,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":81,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":82,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":83,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":84,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":85,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":86,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":87,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":88,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":89,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":90,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":91,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":92,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":93,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":94,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":95,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":96,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":97,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":98,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":99,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":100,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":101,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":102,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":103,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":104,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":105,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":106,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":107,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":108,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":109,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":110,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":111,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":112,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":113,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":114,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":115,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":116,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":117,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":118,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":119,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":120,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":121,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":122,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":123,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":124,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":125,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":126,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":127,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":128,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":129,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":130,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":131,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":132,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":133,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":134,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":135,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":136,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":137,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":138,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":139,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":140,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":141,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":142,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":143,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":144,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":145,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":146,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":147,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":148,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":149,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":150,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":151,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":152,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":153,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":154,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":155,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":156,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":157,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":158,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":159,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":160,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":161,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":162,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":163,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":164,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":165,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":166,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":167,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":168,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":169,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":170,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":171,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":172,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":173,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":174,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":175,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":176,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":177,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":178,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":179,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":180,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":181,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":182,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":183,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":184,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":185,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":186,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":187,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":188,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":189,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":190,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":191,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":192,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":193,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":194,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":195,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":196,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":197,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":198,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":199,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":200,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":201,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":202,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":203,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":204,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":205,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":206,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":207,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":208,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":209,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":210,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":211,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":212,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":213,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":214,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":215,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":216,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":217,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":218,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":219,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":220,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":221,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":222,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":223,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":224,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":225,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":226,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":227,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":228,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":229,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":230,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":231,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":232,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }, 
                {
                 "id":233,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":false
                        }]
                }],
         "tilewidth":60
        }],
 "tilewidth":60,
 "type":"map",
 "version":"1.6",
 "width":230
}